import { render, staticRenderFns } from "./CombinedPredictTableControls.vue?vue&type=template&id=7f8da531"
import script from "./CombinedPredictTableControls.vue?vue&type=script&setup=true&lang=js"
export * from "./CombinedPredictTableControls.vue?vue&type=script&setup=true&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports